import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import OtpLogin from "./OtpLogin";
import PasswordLogin from "./PassworLogin";
import Link from "next/link";

const Login = ({
  loginType = "otp",
  twoModeActive = true,
  targetPath,
  onSuccess,
  changeMobileNumber,
  nig,
  nigData,
  isMerchant,
  loginFromQr = false,
  typeOfLogin,
  setTypeOfLogin,
  noFooter = false,
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState({});
  const router = useRouter();
  useEffect(() => {
    setTypeOfLogin(loginType);
  }, [loginType]);

  // useEffect(() => {
  //   if (searchParams.get("status") === "verifyPhone") {
  //     setStatus("verify");
  //   } else {
  //     setStatus("phone");
  //   }
  // }, []);

  // =>

  const switchLoginMode = (phone, countryCode) => {
    setCountryCode(countryCode);
    setPhoneNumber(phone);
  };

  return (
    <>
      {typeOfLogin === "password" && (
        <>
          <PasswordLogin
            onSuccess={onSuccess}
            switchMode={switchLoginMode}
            baseInfo={{ phoneNumber, countryCode }}
            loginFromQr={loginFromQr}
          />
          {twoModeActive && (
            <div className=" d-flex flex-column align-items-center">
              <div className="d-flex align-items-center mt-5 justify-content-center">
                {" "}
                {/* <span>رمز عبور ندارید؟</span> */}
                <button
                  className="btn btn-none text-primary   "
                  onClick={() => setTypeOfLogin("otp")}
                >
                  ثبت‌نام یا ورود با رمز یک‌بارمصرف
                  {/* ورود با رمز یک‌بارمصرف */}
                </button>
              </div>
              <Link href="/reset/password#password">
                <span
                  style={{ cursor: "pointer" }}
                  className="my-4 text-primary"
                >
                  کلمه عبور خود را فراموش کرده‌اید؟
                </span>
              </Link>
            </div>
          )}
          <div className="d-flex flex-column align-items-center">
            <p className="p-0 m-0 mt-4">با ورود یا ثبت‌نام در شبکه «نسیبا»، </p>
            <p className="m-0 p-0">
              <a
                className="link-primary"
                href="https://nasiba.ir/terms/"
                target="_blank"
                rel="noreferrer"
              >
                قوانین و شرایط استفاده
              </a>{" "}
              را می‌پذیرم.
            </p>
          </div>
        </>
      )}
      {typeOfLogin === "otp" && (
        <>
          {" "}
          <OtpLogin
            buttonText={noFooter ? "ورود" : undefined}
            targetPath={targetPath}
            onSuccess={onSuccess}
            changeMobileNumber={changeMobileNumber}
            nig={nig}
            nigData={nigData}
            isMerchant={isMerchant}
            switchMode={switchLoginMode}
            baseInfo={{ phoneNumber, countryCode }}
            twoModeActive={twoModeActive}
            loginFromQr={loginFromQr}
          />
          {!noFooter &&
            twoModeActive &&
            router.query.status !== "verifyPhone" && (
              <button
                style={{ paddingInline: "9%" }}
                tabIndex={4}
                className="btn   border-primary bg-transparent text-primary align-self-center  mt-4"
                onClick={() => setTypeOfLogin("password")}
              >
                ورود با رمز عبور
              </button>
            )}
          <div
            className={`d-flex flex-column align-items-center ${noFooter ? "d-none" : ""}`}
          >
            <p className="p-0 m-0 mt-4">با ورود یا ثبت‌نام در شبکه «نسیبا»، </p>
            <p className="m-0 p-0">
              <a
                className="link-primary"
                href="https://nasiba.ir/terms/"
                target="_blank"
                rel="noreferrer"
              >
                قوانین و شرایط استفاده
              </a>{" "}
              را می‌پذیرم.
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default Login;
